
window.addEventListener('load', () => {
    const stageSiteMapPanels = document.querySelectorAll('.stage-sitemap-panel');

    for (const stageSiteMapPanel of stageSiteMapPanels) {
        const siteHeader      = document.getElementById('siteHeader');
        const lotTcs          = stageSiteMapPanel.querySelector('#lot-selector-tcs');
        const lotSelectorAnchor = stageSiteMapPanel.querySelector('#lotSelector');

        stageSiteMapPanel.querySelectorAll('#lotSortChange').forEach((btn) => {
            btn.addEventListener('click', () => lotSortChange(btn));
        });

        stageSiteMapPanel.querySelectorAll('#lotSortReverse').forEach((btn) => {
            btn.addEventListener('click', () => lotSortReverse(btn));
        });

        stageSiteMapPanel.querySelectorAll('.lot-selector').forEach((select) => {
            select.addEventListener('change', () => {
                lotUpdateSelected(select);

                lotTcs?.classList.remove('hidden');

                if (lotSelectorAnchor) {
                    if (siteHeader) {
                        const offset = siteHeader.offsetHeight + parseFloat(getComputedStyle(document.documentElement).fontSize);
                        window.scrollBy({ top: lotSelectorAnchor.getBoundingClientRect().top - offset, behavior: 'smooth' });
                    } else {
                        lotSelectorAnchor.scrollIntoView({ behavior: 'smooth' });
                    }
                }
            });
        });
    }
});


// Updates visible Lot Card and syncs all selectors to the selected value.
// Also updates any hidden lot number fields inside forms within the panel.
function lotUpdateSelected(element) {
    const selectedLot = element.value;
    const panel = element.closest('.stage-sitemap-panel');

    panel.querySelectorAll('select').forEach((selector) => {
        selector.value = selectedLot;
    });

    panel.querySelectorAll('.lot-info-cards').forEach((card) => {
        card.classList.toggle('hidden', card.dataset.lot !== selectedLot);
    });

    panel.querySelectorAll('form').forEach((form) => {
        const lotNumberField = form.querySelector('input[name=lotNumber]');
        if (lotNumberField) lotNumberField.value = selectedLot;
    });
}


// Cycles sort method: lot # → area → frontage → lot #
const SORT_CYCLE = [
    { key: 'sortedLotsAlphabet',  next: 'sortedLotsArea',      label: 'Sort by lot area' },
    { key: 'sortedLotsArea',      next: 'sortedLotsFrontage',   label: 'Sort by lot frontage' },
    { key: 'sortedLotsFrontage',  next: 'sortedLotsAlphabet',   label: 'Sort by lot #' },
];

function lotSortChange(element) {
    const current = SORT_CYCLE.find(s => s.key === element.dataset.activeSort);
    if (!current) return;

    element.querySelector('span').textContent = current.label;
    element.dataset.activeSort = current.next;

    element.closest('.stage-sitemap-panel').querySelectorAll('select').forEach((selector) => {
        selector.classList.toggle('hidden', selector.dataset.filter !== current.next);
        selector.selectedIndex = 0;
    });
}


// Reverses option order in all selects (placeholder always stays first).
function lotSortReverse(element) {
    // Toggle icon bar widths
    element.querySelectorAll('.icon div').forEach((child) => {
        const isWide = child.classList.contains('w-4');
        child.classList.toggle('w-4', !isWide);
        child.classList.toggle('w-2', isWide);
    });

    // Toggle ascending/descending label
    const span = element.querySelector('span');
    span.textContent = span.textContent !== span.dataset.descending
        ? span.dataset.descending
        : span.dataset.ascending;

    // Reverse non-placeholder options; re-prepend placeholder to keep it first
    element.closest('.stage-sitemap-panel').querySelectorAll('select').forEach((selector) => {
        const options = [...selector.options].filter(o => o.value !== 'placeholder');
        options.reverse().forEach(o => selector.appendChild(o));
        const placeholder = selector.querySelector('option[value="placeholder"]');
        if (placeholder) selector.prepend(placeholder);
        selector.selectedIndex = 0;
    });
}

